import { NoteUser } from '../UserApi/UserModel';

export enum NoteSortDirection {
	ASC = 'ASC',
	DESC = 'DESC',
}

export interface Note {
	noteId: string;
	usersData: NoteUser[];
	messages: NoteMessage[];
	metadata: NoteMeta;
}

export interface NoteMeta {
	noteId: string;
	discussionMessageId: string;
	groupId: string;
	creatorId: string;
	participants: string[];
	numMessages: number;
	numUnreadMessagesSinceJoin: number;
	subject: string;
}

export interface NoteMessage {
	noteId: string;
	noteMessageId: string;
	authorId: string;
	message: string;
	creationDateTime: string;
	editedDateTime: string;
	readStatus: ReadStatus;
}

export enum ReadStatus {
	READ = 'READ',
	UNREAD = 'UNREAD',
	BEFORE_JOIN = 'BEFORE_JOIN',
}

type HasNoteId = Note | NoteMeta;

export function isNoteEqual(a: HasNoteId, b: HasNoteId): boolean {
	return a.noteId === b.noteId;
}

export function isNoteMessageEqual(a: NoteMessage, b: NoteMessage): boolean {
	return a.noteMessageId === b.noteMessageId;
}
